import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/fuel-economy-calculator',
  component: () => import('../../routes/FuelEconomyCalculator.svelte'),
  card: {
    id: 'fuel-economy',
    title: 'Fuel Economy',
    description: 'Calculate your vehicle\'s MPG, L/100km, cost per mile, and total trip fuel cost from miles driven and gallons used.',
    icon: 'local_gas_station',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/fuel-economy-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Fuel Economy Calculator – MPG, L/100km & Trip Cost',
    description: 'Free fuel economy calculator. Calculate MPG, L/100km, cost per mile, and total trip fuel cost. Also converts between US MPG and European L/100km standards.',
  },
};

export default meta;